module.exports = __webpack_public_path__ + "img/exmo.52c1cd8a.svg";